module.exports = __webpack_public_path__ + "img/fig10.c1b5e393.jpg";